

export const Families =
[
    {name:"Pequena Família Gingadinho",
        address: "R. Anum Dourado, 75 (Na igreja)",
        desc: "Sextas-Feiras  |  Às 20:30",
        owners: "Fernando e Angela Queiroz, Jonathan e Stefani Rocha",
        addressLink: "https://maps.app.goo.gl/5KEXTVk2xh3TH8TR8"
    },
    {
        name:"Pequena Família Dom José",
        address: "R. Luís de Oliveira, 260 - Jd. Dom José, Cond. Portal dos Principes",
        desc: "Quintas-Feiras  |  Às 20:30",
        owners: "Lusinelza Souza",
        addressLink: "https://maps.app.goo.gl/FxRParhUcNrpAqvf8"
    },
    {
        name:"Pequena Família Jd. São Bento ",
        address: "R. Consciência Popular, 109 - COHAB Jd. São Bento, São Paulo",
        desc: "Sextas-Feiras  |  Às 20:30",
        owners: "Fernando e Elaine Braga",
        addressLink: "https://maps.app.goo.gl/DDrEjrRMkBVfxuBD6"
    },
    {
        name: "Pequena Família Pres. Kennedy",
        address: "R. Márcia, 594 - Embu das Artes",
        desc: "Sextas-Feiras  |  Às 20:30",
        owners: "Claudio e Marina Fernandes, Eurides e Rogério Santos",
        addressLink: "https://maps.app.goo.gl/kiWkqxDCgAtVNbbw7"
    },
    {
        name:"Pequena Família Jd. Emílio Carlos",
        address: "R. Rodrigues Alves, 16 - Jd. Emílio Carlos, Embu das Artes",
        desc: "Sextas-Feiras  |  Às 20:30",
        owners: "Vanderley e Camila Pereira",
        addressLink: "https://maps.app.goo.gl/vbA28qtjuH18pwd76"
    },
    {
        name:"Pequena Família Jd. Júlia",
        address: "R. Los Angeles, 179 - Embu Das Artes",
        desc: "Sextas-Feiras  |  Às 20:30",
        owners: "José Carlos & Sueli de Jesus",
        addressLink: "https://maps.app.goo.gl/UToDpMXANmEUnMyo7"
    }
]